module.exports = {
	"ha": "nha",
	"id": 2.1,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 430,
			"marginLeft": 150,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 2.1</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing for Northern Health and HSDA <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 400,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Northeast",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2288.312122732594,
					2250.682596430888,
					2341.923839394029,
					2578.094223726637,
					2584.444730334348,
					2573.0249664049793,
					3058.227264873582,
					3103.234564986424,
					3438.2687859994403,
					{
						"y": 3467.307412261541,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northeast</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Interior",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2360.9261382655204,
					2449.2637291603032,
					2566.7438053846586,
					3232.1530937940115,
					3822.074154591077,
					4632.6678945177155,
					5438.740411323633,
					5319.789588245964,
					5577.589951366093,
					{
						"y": 5736.0521420558625,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Interior</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northwest",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2160.2465749704684,
					2249.6943350088304,
					2264.406779661017,
					2667.6368828601244,
					3157.9092273171536,
					3566.4653191518637,
					4079.6298892471614,
					4367.559313406668,
					4552.934722984092,
					{
						"y": 4943.018947074041,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 15,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northwest</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "All Northern Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": -1,
				"data": [
					2291.0420292392855,
					2350.023870770064,
					2434.29419245443,
					2928.107997198186,
					3347.791062942131,
					3850.106810998902,
					4501.1939316813705,
					4532.442575429123,
					4797.131169542297,
					{
						"y": 4979.8776647416125,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">All Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_2_1.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_2_1.json
// module id = 256
// module chunks = 0